export { default } from './CombinedFieldCDS';
